export default __webpack_public_path__ + "static/media/mobileWef1.2c9ad15b.png";